import EVENTS from "core/customEvent/events.js";
import _ from "lodash";
import Input from "core/input";
import math from "core/math";
import triggerEvent from "core/customEvent/triggerEvent.js";
import { getEnabledElement } from "component/toolManager/enabledElements.js";
import Config from "config";
let isClickEvent = true;
let preventClickTimeout;
const clickDelay = 400;

let mouseMoveForDragHandler = null;

function getEventButtons(event) {
  if (typeof event.buttons === "number") {
    return event.buttons;
  }

  // eslint-disable-next-line default-case
  switch (Input.Mouse.NormalizeMouseEvent.buttons(event)) {
    // No button
    case 0:
      return 0;
    // Left
    case 1:
      return 1;
    // Middle
    case 2:
      return 4;
    // Right
    case 3:
      return 2;
  }

  return 0;
}

function preventClickHandler() {
  isClickEvent = false;
}

let instance = null;

class MouseEventDispatcher {
  constructor() {
    if (instance) return instance;
    instance = this;
  }

  disableMouseEventListen = (element) => {
    element.removeEventListener("mousedown", this.onMouseDownHandler);
    element.removeEventListener("mousemove", this.onMouseMoveHandler);
    // @FIX : MPR UI 동작 이슈. MPR 기능 개발시 아래 핸들러는
    // 주석  처리 하였으나, 아래를 막으면 MouseUp 관련도구 기능에 문제가 생김
    // 마우스 동작에 대한 이벤트 디스패처를 세분화하여 제정리가 필요. 도구에 전달되는 마우스 이벤트처리도
    // 재정립이 필요
    element.removeEventListener("mouseup", this.onMouseUpHandler.bind(this));
  };

  enableMouseEventListen = (element) => {
    element.addEventListener("mousedown", this.onMouseDownHandler);
    element.addEventListener("mousemove", this.onMouseMoveHandler.bind(this));
    // @FIX : MPR UI 동작 이슈. MPR 기능 개발시 아래 핸들러는
    // 주석  처리 하였으나, 아래를 막으면 MouseUp 관련도구 기능에 문제가 생김
    // 마우스 동작에 대한 이벤트 디스패처를 세분화하여 제정리가 필요. 도구에 전달되는 마우스 이벤트처리도
    // 재정립이 필요
  };

  onMouseDownHandler = (e) => {
    const that = this;
    const enabledElement = getEnabledElement(e.currentTarget);
    let viewport = enabledElement.viewport;

    if (typeof viewport === undefined) {
      return false;
    }

    if (viewport === null || viewport === undefined) {
      return false;
    }

    const imageData = enabledElement.image;
    if (!imageData) {
      return;
    }

    const imageIndex = enabledElement.imageIdx;

    const element = e.currentTarget;
    const elementStub = getEnabledElement(element);
    elementStub["element"] = element;

    preventClickTimeout = setTimeout(preventClickHandler, clickDelay);

    element.removeEventListener("mousemove", this.onMouseMovehandler);

    const startPoints = {
      page: math.point.pageToPoint(e),
      image: math.coordinate.pageToPixel(element, e.pageX, e.pageY),
      client: {
        x: e.clientX,
        y: e.clientY,
      },
    };

    startPoints.canvas = math.coordinate.pixelToCanvas(
      element,
      startPoints.image
    );

    let lastPoints = math.copyPoints(startPoints);

    const eventData = {
      event: e,
      buttons: getEventButtons(e),
      viewport: viewport,
      image: imageData,
      imageIndex: imageIndex,
      element: elementStub,
      startPoints,
      lastPoints,
      currentPoints: startPoints,
      deltaPoints: {
        x: 0,
        y: 0,
      },
      type: EVENTS.MOUSE_DOWN,
      which: Input.Mouse.NormalizeMouseEvent.buttons(e),
    };

    const eventPropagated = triggerEvent(
      elementStub.element,
      EVENTS.MOUSE_DOWN,
      eventData
    );

    if (eventPropagated) {
      // No tools responded to this event, create a new tool
      eventData.type = EVENTS.MOUSE_DOWN_ACTIVATE;
      triggerEvent(
        eventData.element.element,
        EVENTS.MOUSE_DOWN_ACTIVATE,
        eventData
      );
    }

    function onMouseMove(e) {
      element.removeEventListener("mouseup", that.onMouseUpHandler);
      document.removeEventListener("mouseup", onMouseUp);
      // Calculate our current points in page and image coordinates
      const eventType = EVENTS.MOUSE_DRAG;

      const elementStub = getEnabledElement(element);
      elementStub.element = element;

      const currentPoints = {
        page: math.point.pageToPoint(e),
        image: math.coordinate.pageToPixel(element, e.pageX, e.pageY),
        client: {
          x: e.clientX,
          y: e.clientY,
        },
      };

      currentPoints.canvas = math.coordinate.pixelToCanvas(
        element,
        //elementStub,
        currentPoints.image
      );

      // Calculate delta values in page and image coordinates
      const deltaPoints = {
        page: math.point.subtract(currentPoints.page, lastPoints.page),
        image: math.point.subtract(currentPoints.image, lastPoints.image),
        client: math.point.subtract(currentPoints.client, lastPoints.client),
        canvas: math.point.subtract(currentPoints.canvas, lastPoints.canvas),
      };

      const eventData = {
        buttons: getEventButtons(e),
        viewport: viewport,
        image: imageData,
        imageIndex: imageIndex,
        //element,
        element: elementStub,
        startPoints,
        lastPoints,
        currentPoints,
        deltaPoints,
        type: eventType,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        shiftKey: e.shiftKey,
        which: Input.Mouse.NormalizeMouseEvent.buttons(e),
      };
      triggerEvent(elementStub.element, eventType, eventData);
      lastPoints = math.copyPoints(currentPoints);
      document.addEventListener("mouseup", onMouseUp);
    }

    // Hook mouseup so we can unbind our event listeners
    // When they stop dragging
    function onMouseUp(e) {
      // Cancel the timeout preventing the click event from triggering
      clearTimeout(preventClickTimeout);
      const elementStub = getEnabledElement(element);

      let eventType = EVENTS.MOUSE_UP;

      if (isClickEvent) {
        eventType = EVENTS.MOUSE_CLICK;
      }

      // Calculate our current points in page and image coordinates
      const currentPoints = {
        page: math.point.pageToPoint(e),
        image: math.coordinate.pageToPixel(element, e.pageX, e.pageY),
        client: {
          x: e.clientX,
          y: e.clientY,
        },
      };

      currentPoints.canvas = math.coordinate.pixelToCanvas(
        element,
        currentPoints.image
      );

      // Calculate delta values in page and image coordinates
      const deltaPoints = {
        page: math.point.subtract(currentPoints.page, lastPoints.page),
        image: math.point.subtract(currentPoints.image, lastPoints.image),
        client: math.point.subtract(currentPoints.client, lastPoints.client),
        canvas: math.point.subtract(currentPoints.canvas, lastPoints.canvas),
      };

      const eventData = {
        event: e,
        buttons: getEventButtons(e),
        viewport: viewport,
        image: imageData,
        imageIndex: imageIndex,
        element: elementStub,
        startPoints,
        lastPoints,
        currentPoints,
        deltaPoints,
        type: eventType,
        drag: true,
        which: Input.Mouse.NormalizeMouseEvent.buttons(e),
      };
      triggerEvent(elementStub.element, eventType, eventData);

      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);

      element.addEventListener("mouseup", that.onMouseUpHandler);
      element.addEventListener("mousemove", that.onMouseMoveHandler);

      isClickEvent = true;
    }
    mouseMoveForDragHandler = onMouseMove;
    document.addEventListener("mousemove", onMouseMove);

    return true;
  };

  onMouseMoveHandler(e) {
    const element = e.currentTarget;
    const elementStub = getEnabledElement(element);
    if (_.get(e, "pageX", false) === false) {
      e.pageX = e.detail.pageX;
    }
    if (_.get(e, "pageY", false) === false) {
      e.pageY = e.detail.pageY;
    }
    let viewport = elementStub.viewport;

    if (typeof viewport === undefined) {
      return false;
    }

    if (viewport === null || viewport === undefined) {
      return false;
    }

    const imageData = elementStub.image;
    if (!imageData) {
      return;
    }
    const imageIndex = elementStub.imageIdx;
    if (!_.get(elementStub, "canvas")) {
      return;
    }

    const eventType = EVENTS.MOUSE_MOVE;

    const startPoints = {
      page: math.point.pageToPoint(e),
      image: math.coordinate.pageToPixel(element, e.pageX, e.pageY),
      client: {
        x: e.clientX,
        y: e.clientY,
      },
    };

    startPoints.canvas = math.coordinate.pixelToCanvas(
      element,
      startPoints.image
    );

    let lastPoints = math.copyPoints(startPoints);

    // Calculate our current points in page and image coordinates
    const currentPoints = {
      page: math.point.pageToPoint(e),
      image: math.coordinate.pageToPixel(element, e.pageX, e.pageY),
      client: {
        x: e.clientX,
        y: e.clientY,
      },
    };

    currentPoints.canvas = math.coordinate.pixelToCanvas(
      element,
      currentPoints.image
    );

    // Calculate delta values in page and image coordinates
    const deltaPoints = {
      page: math.point.subtract(currentPoints.page, lastPoints.page),
      image: math.point.subtract(currentPoints.image, lastPoints.image),
      client: math.point.subtract(currentPoints.client, lastPoints.client),
      canvas: math.point.subtract(currentPoints.canvas, lastPoints.canvas),
    };

    const eventData = {
      viewport: viewport,
      image: imageData,
      imageIndex: imageIndex,
      canvas: element.canvas,
      element: elementStub,
      startPoints,
      lastPoints,
      currentPoints,
      deltaPoints,
      type: eventType,
      which: Input.Mouse.NormalizeMouseEvent.buttons(e),
    };

    triggerEvent(element, eventType, eventData);
    // Update the last points
    lastPoints = math.copyPoints(currentPoints);

    return true;
  }
  onMouseUpHandler(e) {
    const element = e.currentTarget;
    document.removeEventListener("mousemove", mouseMoveForDragHandler);

    const enabledElement = getEnabledElement(element);

    let viewport = enabledElement.viewport;
    if (typeof viewport === undefined) {
      return false;
    }

    if (viewport === null || viewport === undefined) {
      return false;
    }
    if (!_.get(enabledElement, "canvas")) {
      return;
    }

    const eventType = EVENTS.MOUSE_UP;

    const startPoints = {
      page: math.point.pageToPoint(e),
      image: math.coordinate.pageToPixel(element, e.pageX, e.pageY),
      client: {
        x: e.clientX,
        y: e.clientY,
      },
    };

    startPoints.canvas = math.coordinate.pixelToCanvas(
      element,
      startPoints.image
    );

    let lastPoints = math.copyPoints(startPoints);

    // Calculate our current points in page and image coordinates
    const currentPoints = {
      page: math.point.pageToPoint(e),
      image: math.coordinate.pageToPixel(element, e.pageX, e.pageY),
      client: {
        x: e.clientX,
        y: e.clientY,
      },
    };

    currentPoints.canvas = math.coordinate.pixelToCanvas(
      element,
      currentPoints.image
    );

    // Calculate delta values in page and image coordinates
    const deltaPoints = {
      page: math.point.subtract(currentPoints.page, lastPoints.page),
      image: math.point.subtract(currentPoints.image, lastPoints.image),
      client: math.point.subtract(currentPoints.client, lastPoints.client),
      canvas: math.point.subtract(currentPoints.canvas, lastPoints.canvas),
    };

    const imageData = enabledElement.image;
    if (!imageData) {
      return;
    }
    const imageIndex = enabledElement.imageIdx;

    const eventData = {
      event: e,
      buttons: getEventButtons(e),
      viewport: viewport,
      image: imageData,
      imageIndex: imageIndex,
      element: enabledElement,
      startPoints,
      lastPoints,
      currentPoints,
      deltaPoints,
      type: eventType,
      drag: false,
      which: Input.Mouse.NormalizeMouseEvent.buttons(e),
    };
    triggerEvent(element, eventType, eventData);
  }
}

export default MouseEventDispatcher;
